export const assetRegExp = /^(.*)(\/\*)(\+[^*]+)(\*\/)/g;
export const codeFolds = {
  prefix: '// ',
  startWord: '// ここから',
  endWord: '// ここまで'
};
